export default import.meta.ROLLDOWN_FILE_URL_mZSGuTP0BEpcyfQ9d5s09A